import { Component } from "@angular/core";

@Component({
  selector: "app-logout",
  template: ` <h1>I am logout</h1> `,
  styleUrls: ["./logout.component.scss"],
})
export class LogoutComponent {}
